import React, { FC, memo } from 'react';
import { Button } from 'antd';

import Modal, { ModalHeader, ModalFooter } from '@/components/Common/Modal';
import i18n from '@/content';
import styles from './DiscardNewPolicyModal.module.scss';

export { default as useDiscardModal } from './useDiscardModal';

interface DiscardNewPolicyProps {
    isVisible: boolean;
    onFinish: (isConfirmed: boolean) => void;
}

const nameSpace = 'policyEditor.discardModal';

const DiscardNewPolicyModal: FC<DiscardNewPolicyProps> = ({ isVisible, onFinish }) => {
    const handleConfirm = (): void => {
        onFinish(true);
    };

    const handleCancel = (): void => {
        onFinish(false);
    };

    return (
        <Modal
            isOpen={isVisible}
            closeModal={handleCancel}
            destroyOnClose
            initStyle={{ initWidth: 520 }}
        >
            <>
                <ModalHeader>
                    <div className={styles.title}>
                        {i18n.t(`${nameSpace}.title`)}
                    </div>
                </ModalHeader>
                <div className={styles.content}>
                    {i18n.t(`${nameSpace}.content`)}
                </div>
                <ModalFooter>
                    <div className={styles['buttons-container']}>
                        <Button data-testid="discardPolicyModal_cancelButton" onClick={handleCancel} className={styles['cancel-button']}>
                            {i18n.t('general.buttons.cancel')}
                        </Button>
                        <Button data-testid="discardPolicyModal_confirmButton" onClick={handleConfirm} type="primary" className={styles['confirm-button']}>
                            {i18n.t('general.buttons.ok')}
                        </Button>
                    </div>
                </ModalFooter>
            </>
        </Modal>
    );
};

export default memo(DiscardNewPolicyModal);
